import { ReactComponent as InfoIcon } from "../../images/infoIcon.svg";
import { ReactComponent as SuccessIcon } from "../../images/successIcon.svg";
import { ReactComponent as ErrorIcon } from "../../images/errorIcon.svg";
import { NOTIFICATION_TYPE_ENUM } from "interfaces";

export const getIcon = (type: string) => {
  switch (type) {
    case NOTIFICATION_TYPE_ENUM.SUCCESS:
      return <SuccessIcon />;
    case NOTIFICATION_TYPE_ENUM.ERROR:
      return <ErrorIcon />;
    case NOTIFICATION_TYPE_ENUM.INFO:
      return <InfoIcon />;
    case NOTIFICATION_TYPE_ENUM.NOTICE:
      return <InfoIcon />;
    default:
      return <InfoIcon />;
  }
};
